export interface ModuleDefinition {
  selector: string;
  moduleName: string;
  defaultArgs?: Record<string, unknown>;
}

/**
 * This array controls the async modules
 * "selector" @string the string given to querySelectorAll(); needs to be valid for this fn
 * "moduleName" @string the file name of the module you wish to load without the extension
 * "defaultArgs" @object object of defaultArgs you wish to instantiate with
 *
 * You can also use HTML data attributes that will be converted to an object and passed to module too
 * data-test-attribute="foo" will convert to {testAttribute: 'foo'}
 *
 * JSON objects will be parsed too as long as you print it correctly using something like :
 * htmlspecialchars(json_encode($array, ENT_QUOTES, 'UTF-8')
 */
const moduleDefinition: ModuleDefinition[] = [
  { selector: '.testing', moduleName: 'DummyClass' },
  { selector: '.section--image-scroller', moduleName: 'ImageScroller' },
  { selector: '.section--video-feature', moduleName: 'VideoFeature' },
  { selector: '.section--timeline', moduleName: 'Timeline' },
  { selector: '.section--image-swiper', moduleName: 'ImageSwiper' },
  { selector: '.swiper.swiper--post-cards', moduleName: 'PostCardSwiper' },
  { selector: '.section--products', moduleName: 'Products' },
  { selector: '#page-navigation', moduleName: 'Navigation' },
  { selector: '.section', moduleName: 'SectionObserver' },
  { selector: '.section--features', moduleName: 'FeaturesAnimations' },
  { selector: '[data-custom-swiper]', moduleName: 'CustomSwiper' },
  // { selector: '.header--gradient', moduleName: 'HeaderAnimation' },
];

export default moduleDefinition;
